import {useMemo} from "react";
import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";
import getSingleAndReturnAmenities
    from "@CheckOrder/features/amenities/features/countAmenity/functions/getSingleAndReturnAmenities";
import createObjectFromAmenityList
    from "@CheckOrder/features/amenities/features/countAmenity/features/list/functions/createObjectFromAmenityList";
import entries from "@Object/entries";

export default function useGetAmenitiesByDirection(pairedAmenityGroups: PairedSingleAndReturnAmenitiesType, selectedTab: "single" | "return") {
    const {
        singleAmenities,
        returnAmenities,
    } = getSingleAndReturnAmenities(pairedAmenityGroups)

    const singleAmenitiesRecord = useMemo(() => (createObjectFromAmenityList(singleAmenities)), [])
    const returnAmenitiesRecord = useMemo(() => (createObjectFromAmenityList(returnAmenities)), [])

    const getAmenitiesByDirection = (amenityKey: string) => {
        if (selectedTab === "single") {
            return {
                amenity: singleAmenitiesRecord[amenityKey],
                amenityInDifferentDirection: returnAmenitiesRecord[amenityKey],
            }
        }

        return {
            amenity: returnAmenitiesRecord[amenityKey],
            amenityInDifferentDirection: singleAmenitiesRecord[amenityKey],
        }
    }

    return {
        getAmenitiesByDirection,
        hasAmenitiesInThisDirection: !!entries(singleAmenitiesRecord).length,
    }
}